<template>
  <div class="training-page">
    <!-- 顶部区域 -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">🎯 培训记录</h1>
        <p class="page-subtitle">记录您的学习历程</p>
      </div>
    </div>

    <!-- 培训列表 -->
    <div class="training-container">
      <!-- 列表骨架屏 -->
      <div class="training-skeleton-list" v-if="loading">
        <div class="training-skeleton-card" v-for="i in 5" :key="i">
          <div class="skeleton-thumb"></div>
          <div class="skeleton-content">
            <div class="skeleton-line skeleton-title-line"></div>
            <div class="skeleton-line skeleton-title-line-short"></div>
            <div class="skeleton-footer">
              <div class="skeleton-line skeleton-status"></div>
              <div class="skeleton-line skeleton-tag"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="training-list" v-else-if="trainingList.length > 0">
        <div
          class="course-card-h"
          v-for="(item, index) in trainingList"
          :key="index"
          @click="onClickItem(item)"
        >
          <div class="card-thumb">
            <div class="thumb-skeleton"></div>
            <img :src="getThumb(item)" :alt="item.Subject" class="thumb-img" />
          </div>
          <div class="card-content">
            <h4 class="card-title">{{ item.Subject }}</h4>
            <div class="card-footer">
              <span v-if="item.Status === 1" class="card-status unlocked">已完成</span>
              <span v-else class="card-status locked">进度 {{ getProgress(item) }}%</span>
              <span class="content-type-tag" v-if="getItemType(item)">{{ getItemType(item) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="!loading && trainingList.length === 0" class="empty-state">
        <div class="empty-icon">📚</div>
        <p class="empty-title">暂无培训记录</p>
        <p class="empty-desc">开始学习课程后，这里会显示您的学习进度</p>
      </div>
    </div>

    <!-- 前往学习确认弹框 -->
    <van-dialog
      v-model="showGoStudyConfirm"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :lock-scroll="false"
      :close-on-click-overlay="true"
      get-container="body"
      class="study-confirm-dialog"
      @closed="selectedItem = null"
    >
      <div class="confirm-dialog-content">
        <div class="confirm-dialog-thumb">
          <img :src="selectedItem ? getThumb(selectedItem) : ''" alt="" />
        </div>
        <div class="confirm-dialog-title">{{ selectedItem ? selectedItem.Subject : '' }}</div>
        <div class="confirm-dialog-tip">是否继续学习该课程？</div>
        <div class="confirm-dialog-actions">
          <button class="dialog-btn cancel" @click="closeGoStudyConfirm">取消</button>
          <button class="dialog-btn confirm" @click="goStudy">前往学习</button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { WeChatMemberCultivate_GetMemberCultivateList } from '../api/api'

export default {
  name: 'training_list',
  data () {
    return {
      trainingList: [],
      loading: true, // 加载状态
      showGoStudyConfirm: false,
      selectedItem: null,
      pageScrollTop: 0,
      pageLocked: false,
      pageLockStyle: null
    }
  },
  watch: {
    showGoStudyConfirm (visible) {
      if (visible) {
        this.lockPageScroll()
      } else {
        this.unlockPageScroll()
      }
    }
  },
  async mounted() {
    this.loading = true
    try {
      const { data } = await WeChatMemberCultivate_GetMemberCultivateList()
      this.trainingList = data.response || []
    } finally {
      this.loading = false
    }
  },
  beforeDestroy () {
    this.unlockPageScroll()
  },
  methods: {
    getProgress(item) {
      if (!item || !item.TotalSeconds || item.TotalSeconds === 0) return 0
      const progress = (item.ViewedSeconds / item.TotalSeconds) * 100
      return Math.min(progress, 100).toFixed(1)
    },
    getItemType (item) {
      const link = item && (item.Link || item.link)
      if (!link || typeof link !== 'string') return ''
      const ext = link.split('.').pop().toUpperCase()
      if (ext === 'MP4' || ext === 'M3U8') return '视频'
      if (ext === 'PDF') return 'PDF'
      return ext
    },
    getThumb (item) {
      let thumb = (item && (item.Thumbnail || item.ImageUrl)) || ''
      if (thumb && !thumb.startsWith('http')) {
        // 图片资源域名
        const baseUrl = 'https://share.51i.cc'
        thumb = baseUrl + (thumb.startsWith('/') ? '' : '/') + thumb
      }
      return thumb || require('../assets/logo.png')
    },
    getCourseId (item) {
      return item.CurriculumId || item.CourseId || item.Id
    },
    onClickItem (item) {
      this.selectedItem = item
      this.showGoStudyConfirm = true
    },
    closeGoStudyConfirm () {
      this.showGoStudyConfirm = false
    },
    lockPageScroll () {
      if (this.pageLocked) return

      const body = document.body
      const doc = document.documentElement
      const scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0

      this.pageScrollTop = scrollTop
      this.pageLockStyle = {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow
      }

      body.style.position = 'fixed'
      body.style.top = '-' + scrollTop + 'px'
      body.style.left = '0'
      body.style.right = '0'
      body.style.width = '100%'
      body.style.overflow = 'hidden'
      this.pageLocked = true
    },
    unlockPageScroll () {
      if (!this.pageLocked) return

      const body = document.body
      const style = this.pageLockStyle || {}
      const scrollTop = this.pageScrollTop || 0

      body.style.position = style.position || ''
      body.style.top = style.top || ''
      body.style.left = style.left || ''
      body.style.right = style.right || ''
      body.style.width = style.width || ''
      body.style.overflow = style.overflow || ''

      this.pageLocked = false
      this.pageLockStyle = null
      this.$nextTick(() => {
        window.scrollTo(0, scrollTop)
      })
    },
    goStudy () {
      const id = this.getCourseId(this.selectedItem)
      if (!id) {
        this.$toast('无法获取课程信息')
        return
      }
      this.unlockPageScroll()
      this.$router.push({ path: '/classStudy', query: { ids: id } })
    }
  }
}
</script>

<style scoped>
.training-page {
  min-height: 100vh;
  background: #f5f9fc;
  /* 移除 transform 以修复 iOS 上 fixed 弹窗定位问题 */
  /* -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden; */
  -webkit-overflow-scrolling: touch;
}

/* 顶部区域 */
.page-header {
  background: #fff;
  padding: 20px 20px 10px;
  position: relative;
  overflow: hidden;
  text-align: center;
  border-bottom: 1px solid #f0f4f8;
}

.header-decoration, .deco-circle, .deco-circle-1, .deco-circle-2 {
  display: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.page-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a2a3a;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
}

.page-subtitle {
  font-size: 13px;
  color: #8a9aaa;
  margin: 0;
}

/* 培训容器 */
.training-container {
  margin-top: 16px;
  padding: 0 16px 30px;
  position: relative;
  z-index: 10;
}

/* 培训列表 */
.training-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 骨架屏样式 */
.training-skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.training-skeleton-card {
  display: flex;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  height: 80px;
}

.skeleton-thumb {
  width: 142px;
  min-width: 142px;
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.skeleton-content {
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-title-line {
  height: 14px;
  width: 90%;
}

.skeleton-title-line-short {
  height: 14px;
  width: 60%;
  margin-top: 6px;
}

.skeleton-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
}

.skeleton-status {
  height: 12px;
  width: 70px;
}

.skeleton-tag {
  height: 18px;
  width: 36px;
  border-radius: 4px;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* 复用首页的横向课程卡片视觉（左图右文） */
.course-card-h {
  display: flex;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  min-height: 80px;
}

.card-thumb { position: relative; width: 142px; min-width: 142px; height: 80px; overflow: hidden; background: #f0f2f5; border-radius: 8px; }
.thumb-skeleton { position: absolute; inset: 0; background: #f0f2f5; }
.thumb-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; background: #f0f2f5; z-index: 1; }

.card-content { flex: 1; padding: 10px 12px; display: flex; flex-direction: column; justify-content: space-between; min-width: 0; }
.card-title { font-size: 14px; font-weight: 600; color: #1a2a3a; margin: 0; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.card-footer { display: flex; justify-content: space-between; align-items: center; margin-top: auto; }
.content-type-tag { font-size: 10px; color: #d51900; background: rgba(213, 25, 0, 0.08); padding: 2px 6px; border-radius: 4px; font-weight: 600; border: 0.5px solid rgba(213, 25, 0, 0.15); }
.card-status { font-size: 12px; font-weight: 600; }
.card-status.unlocked { color: #d51900; }
.card-status.locked { color: #999; }

/* 进度条 */
.progress-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.progress-bar {
  flex: 1;
  height: 8px;
  background: #e8eef3;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #d51900;
  border-radius: 4px;
  transition: width 0.5s ease;
}

.progress-text {
  font-size: 13px;
  font-weight: 600;
  color: #d51900;
  min-width: 45px;
  text-align: right;
}

/* 完成标记 */
.complete-badge {
  display: flex;
  align-items: center;
  gap: 6px;
}

.badge-icon {
  font-size: 14px;
}

.badge-text {
  font-size: 13px;
  font-weight: 600;
  color: #20bf6b;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a2a3a;
  margin: 0 0 8px;
}

.empty-desc {
  font-size: 14px;
  color: #8a9aaa;
  margin: 0;
}

/* 确认弹框样式 */
.study-confirm-dialog .van-dialog__header {
  display: none;
}

.confirm-dialog-content {
  padding: 20px 16px;
  text-align: center;
}

.confirm-dialog-thumb {
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  border-radius: 12px;
  overflow: hidden;
  background: #f5f7fa;
  margin-bottom: 16px;
  position: relative;
}

.confirm-dialog-thumb img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.confirm-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2a3a;
  margin-bottom: 8px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.confirm-dialog-tip {
  font-size: 14px;
  color: #8a9aaa;
  margin-bottom: 20px;
}

.confirm-dialog-actions {
  display: flex;
  gap: 12px;
}

.dialog-btn {
  flex: 1;
  height: 44px;
  border: none;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.dialog-btn:active {
  opacity: 0.8;
}

.dialog-btn.cancel {
  background: #f5f7fa;
  color: #666;
}

.dialog-btn.confirm {
  background: #d51900;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/training_list.vue